import { useLazyQuery } from "@apollo/client/react"; import React, { useEffect, useState, useMemo } from 'react';
import DataGridGenerico from '../../../../components/dataGrid/DataGridGenerico';
import { generateColumnsDefaultConfiguration } from '../../../../components/dataGrid/columnHelpers';

import { GET_DOCUMENTOS } from '../../../../data/graphQL/queries/Planes/getDocumentos';
import { SwitchInput } from '../../../../components/switchInput/SwitchInput';

export const StepFacturacion = ({ stepsData, setStepsData }) => {
  const initialColumns = [
    {
      field: 'idDocumentoFac',
      headerName: '#',
      flex: 0.05
    },
    {
      field: 'nombre',
      headerName: 'Documentacion'
    },
    {
      headerName: '',
      field: 'action',
      flex: 0.05,
      renderCell: (cellProps) => {
        const { row } = cellProps;
        return (
          <SwitchInput
            checked={stepsData.documentoFacturaciones?.some((df) => df?.idDocumentoFac === row.idDocumentoFac)}
            onChange={(e) => handleChangeStatusDocumento(row, e.target.checked)} />);

      }
    }];

  const [documentos, setDocumentos] = useState([]);
  useEffect(() => {
    if (!documentosLoading) {
      getDocumentos();
    }
  }, []);

  const [getDocumentos, { loading: documentosLoading, data: documentosData }] = useLazyQuery(GET_DOCUMENTOS, {
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    if (!documentosData) return;
    setDocumentos(documentosData.documentoFac);
  }, [documentosData])

  const handleChangeStatusDocumento = (row, state) => {
    if (state) {
      setStepsData((previousData) => ({
        ...previousData,
        documentoFacturaciones: [...previousData.documentoFacturaciones, { idPlanCuidado: 0, idDocumentoFac: row.idDocumentoFac }]
      }));
    } else {
      setStepsData((previousData) => ({
        ...previousData,
        documentoFacturaciones: [...(previousData.documentoFacturaciones || []).filter((c) => c.idDocumentoFac !== row.idDocumentoFac)]
      }));
    }
  };

  const columns = useMemo(() => generateColumnsDefaultConfiguration(initialColumns), [stepsData.documentoFacturaciones]);

  return (
    <div>
      <DataGridGenerico
        hideFooterPagination={false}
        columns={columns}
        rows={documentos || []}
        toolbar={false}
        totalCount={documentos.length}
        rowsPerPage={[10]} />

    </div>);

};